import { render, staticRenderFns } from "./ExcelDownloadButton.vue?vue&type=template&id=12279a5c&"
import script from "./ExcelDownloadButton.vue?vue&type=script&lang=ts&"
export * from "./ExcelDownloadButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports